






import { Component, Vue, Prop } from 'vue-property-decorator';
import { ItemDTO } from '@/api';
import LookDynamicCard from '@/components/looks/LookDynamicCard.vue';

@Component({
  name: 'looks-item',
  components: {
    LookDynamicCard,
  },
})
export default class Clients extends Vue {
  @Prop(Object) item!: ItemDTO;

  @Prop(Boolean) selected!: boolean;
}
